import { Affix, Popover, Switch } from '@arco-design/web-react'
import React, { CSSProperties, useEffect, useState } from 'react'
import styled from 'styled-components'
import diamond from 'ASSETS/svg/icon_diamond.svg'
import { ReactComponent as ArrowRight } from 'ASSETS/svg/icon_arrowright.svg'
import About1 from 'ASSETS/png/icon_about_1.png'
import { ReactComponent as About2 } from 'ASSETS/svg/icon_about_2.svg'
import { ReactComponent as More1 } from 'ASSETS/svg/icon_more_1.svg'
import { ReactComponent as More2 } from 'ASSETS/svg/icon_more_2.svg'
import { ReactComponent as More3 } from 'ASSETS/svg/icon_more_3.svg'
import { ReactComponent as Feat1 } from 'ASSETS/svg/icon_feat_1.svg'
import { ReactComponent as Feat2 } from 'ASSETS/svg/icon_feat_2.svg'
import { ReactComponent as Feat3 } from 'ASSETS/svg/icon_feat_3.svg'
import { ReactComponent as Intro1 } from 'ASSETS/svg/intro1.svg'
import { ReactComponent as Intro2 } from 'ASSETS/svg/intro2.svg'
import { ReactComponent as Yes } from 'ASSETS/svg/icon_yes.svg'
import { ReactComponent as Line } from 'ASSETS/svg/icon_line.svg'
import { ReactComponent as Zoom } from 'ASSETS/svg/icon_zoom.svg'
import { ReactComponent as Cut } from 'ASSETS/svg/icon_cut.svg'
import { ReactComponent as HorizontalFlip } from 'ASSETS/svg/icon_horizontal_flip.svg'
import { ReactComponent as Watermask } from 'ASSETS/svg/icon_watermask.svg'
import { ReactComponent as IconAbout } from 'ASSETS/svg/icon_nav_about.svg'
import { ReactComponent as IconMask } from 'ASSETS/svg/icon_mask.svg'
import { ReactComponent as Question } from 'ASSETS/svg/icon_question.svg'
import productImg from 'ASSETS/png/product.png'
import bannerImg from 'ASSETS/png/banner.png'
import feat1Img from 'ASSETS/png/feat1.png'
import feat2Img from 'ASSETS/png/feat2.png'
import feat31 from 'ASSETS/png/feat3_1.png'
import feat32 from 'ASSETS/png/feat3_2.png'
import feat33 from 'ASSETS/png/feat3_3.png'
import feat34 from 'ASSETS/png/feat3_4.png'
import { reportTea } from 'UTILS/tea'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow-x: hidden;
`

const Container = styled.div`
  width: 1200px;
  display: flex;
  justify-content: space-between;
`

const NavGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 900px;
  background: linear-gradient(359.64deg, rgba(245, 248, 255, 0.15) 0.3%, #edf2ff 99.67%);
`

const Header = styled.div`
  width: 100vw;
  height: 60px;
  background: ${(props: { active: boolean }) =>
    props.active ? 'rgba(255, 255, 255, 0.8)' : 'unset'};
  backdrop-filter: ${(props: { active: boolean }) =>
    props.active ? 'blur(10px)' : 'blur(0px)'};
  display: flex;
  align-items: center;
  justify-content: center;
`

const Diamond = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  user-select: none;
  pointer-events: none;
`

const Icon = styled.div`
  cursor: pointer;
`

const ActionContainer = styled.div`
  width: 178px;
  display: flex;
  align-items: center;
`

const Text = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #00114b;
  cursor: pointer;
  :hover {
    color: #165dff;
  }
  display: flex;
  justify-content: center;
  align-items: center;
`

const ActiveText = styled(Text)`
  width: 88px;
  height: 32px;
  background: ${(props: { active: boolean }) => (props.active ? '#3370FF' : 'unset')};
  color: ${(props: { active: boolean }) => (props.active ? '#ffffff' : '#00114B')};
  border-radius: ${(props: { active: boolean }) => (props.active ? '4px' : 'unset')};
  :hover {
    color: ${(props: { active: boolean }) => (props.active ? '#ffffff' : '#165dff')};
    background: ${(props: { active: boolean }) => (props.active ? '#2152D9' : 'unset')};
  }
`

const Title = styled.span`
  height: 84px;
  width: 704px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 64px;
  line-height: 84px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #00114b;
`

const Content = styled.span`
  width: 808px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 32px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4e5a83;
  opacity: 0.8;
`

const ActiveButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  width: 152px;
  height: 52px;
  background: #3370ff;
  box-shadow: 0px -1px 1px #f7f7f8, 0px 5px 12px rgba(147, 157, 168, 0.24);
  border-radius: 8px;
  cursor: pointer;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
  :hover {
    background: #2152d9;
    .arrow-right {
      fill: #2152d9;
      animation-name: move;
      animation-timing-function: ease;
      animation-duration: 1s;
      transform-origin: bottom;
    }
    @keyframes move {
      0% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(16px);
      }
      51% {
        transform: translateX(-16px);
      }
      100% {
        transform: translateX(0);
      }
    }
  }
  box-sizing: border-box;
`

const ArrowContaienr = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

const IconArrowRight = styled(ArrowRight)`
  fill: #3370ff;
  transition: all linear 0.2s;
`

const IconAbout1 = styled.img`
  position: absolute;
  top: -45px;
  left: 18px;
  width: 128px;
  height: 128px;
`
const IconAbout2 = styled(About2)`
  position: absolute;
  top: -24px;
  right: 18px;
`

const ProductImg = styled.img`
  user-select: none;
  pointer-events: none;
  object-fit: cover;
  box-shadow: 0px -1px 40px rgba(102, 112, 147, 0.1),
    0px 27.4092px 30px rgba(193, 198, 215, 0.127269),
    0px 19.0025px 20px rgba(193, 198, 215, 0.113998),
    0px 10.0701px 30px rgba(193, 198, 215, 0.0815545);
  border-radius: 12px;
`

const H2 = styled.span`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 50px;
  color: #282f38;
`
const ActiveH2 = styled(H2)`
  color: #3370ff;
`

const CardContainer = styled.div`
  width: 360px;
  height: 320px;
  background: #ffffff;
  box-shadow: 1px 3px 32px rgba(152, 167, 183, 0.1);
  border-radius: 12px;
  padding: 48px 40px 55px 40px;
  box-sizing: border-box;
`

const MoreTitle = styled.div`
  font-family: Noto Sans SC sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  color: #282f38;
  margin-top: 38px;
  margin-bottom: 12px;
`

const MoreContent = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #4e5a83;
  opacity: 0.8;
`

const IntroContaienr = styled.div`
  width: 580px;
  height: 520px;
  background: #ffffff;
  box-shadow: 0px 8px 50px rgba(225, 234, 244, 0.6);
  border-radius: 12px;
  padding: 0 60px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
`

const IconIntro1 = styled(Intro1)`
  position: absolute;
  right: -50px;
  bottom: -60px;
  width: 400px;
  height: 400px;
`
const IconIntro2 = styled(Intro2)`
  position: absolute;
  right: -50px;
  bottom: -60px;
  width: 400px;
  height: 400px;
`

const IntroTitle = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  color: #00114b;
  margin-top: 60px;
  margin-bottom: 12px;
`

const IntroContent = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  color: #4e5a83;
  opacity: 0.8;
  margin-bottom: 20px;
`

const IntroItemContainer = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 42px;
  color: #00114b;
  opacity: 0.8;
  display: flex;
  align-items: center;
  z-index: 100;
`

const IconYes = styled(Yes)`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`

const IntroItem = (props: { text: string }) => {
  return (
    <IntroItemContainer>
      <IconYes></IconYes>
      <div>{props.text}</div>
    </IntroItemContainer>
  )
}

const TabContainer = styled.div`
  width: 1122px;
  padding-left: 40px;
  padding-right: 22px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
`

const TabCell1 = styled.div`
  width: 410px;
`

const TabCell2 = styled.div`
  width: 308px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TabCell3 = styled.div`
  width: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TabTitle = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #282f38;
`

const TableHeader = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
`

const TabContent = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #505965;
  display: flex;
  align-items: center;
`

const BannerContainer = styled.div`
  background-image: url(${bannerImg});
  height: 280px;
  width: 100%;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const BannerTitle = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 8px;
  width: 112px;
  height: 40px;
`

const BannerContent = styled.div`
  width: 461px;
  height: 48px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.3px;
  color: #ffffff;
  opacity: 0.8;
  margin-bottom: 32px;
`

const BannerBtn = styled.div`
  width: 180px;
  height: 40px;
  background: #ffffff;
  mix-blend-mode: normal;
  box-shadow: inset 0px 4px 8px rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  font-family: Noto Sans SC sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #3370ff;
  :hover {
    filter: drop-shadow(0px 2px 6px #0865f1);
  }
  display: flex;
  justify-content: center;
  align-items: center;
`

const Footer = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #4e5969;
`

const IconFeat1 = styled(Feat1)`
  position: absolute;
  top: 211px;
  left: 0;
  box-shadow: 1px 4px 20px rgba(184, 213, 240, 0.3);
  border-radius: 20px;
`

const IconFeat2 = styled(Feat2)`
  position: absolute;
  top: 240px;
  right: 385px;
  box-shadow: 1px 4px 20px rgba(184, 213, 240, 0.3);
  border-radius: 20px;
`

const IconFeat3 = styled(Feat3)`
  position: absolute;
  top: 211px;
  left: 0;
  box-shadow: 1px 4px 20px rgba(184, 213, 240, 0.3);
  border-radius: 20px;
`

const FeatTitle = styled.span`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 50px;
  color: #282f38;
`

const FeatActiveTitle = styled(FeatTitle)`
  color: #3370ff;
`

const FeatContent = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 32px;
  color: #4e5a83;
  opacity: 0.8;
  position: absolute;
`

const Feat1Cube = styled.div`
  position: absolute;
  width: 516px;
  height: 496px;
  background: #f1f7ff;
  border-radius: 12px;
  right: 0;
  top: 166px;
`

const Feat2Cube = styled.div`
  position: absolute;
  width: 466px;
  height: 485px;
  top: 128px;
  background: #e6eefb;
  border-radius: 12px;
`

const Feat3Cube = styled.div`
  position: absolute;
  width: 508px;
  height: 498px;
  right: 0;
  top: 147px;
  background: #f1f7ff;
  border-radius: 12px;
`

const Feat1ImgContainer = styled.div`
  position: absolute;
  width: 600px;
  height: 338px;
  right: 40px;
  top: 206px;
  box-shadow: 0px -1.22909px 3.68727px rgba(111, 123, 169, 0.1),
    0px 122.909px 98.3273px rgba(217, 225, 250, 0.17),
    0px 33.6884px 9.81248px rgba(193, 198, 215, 0.127269);
  border-radius: 12px;
  pointer-events: none;
  background-color: transparent;
`

const Feat1Tag = styled.div`
  height: 36px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 2.45818px;
  position: absolute;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #000000;
  opacity: 0.5;
`

const SliderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  pointer-events: none;
`

const SliderLine = styled.div`
  height: 320px;
  width: 3px;
  background: white;
  margin: 0 3px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
  transform: translateY(-9px);
`

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 4.5px solid white;
  border-right: 4.5px solid transparent;
  border-top: 4.5px solid transparent;
  border-bottom: 4.5px solid transparent;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.16));
`

const Slider = (props: { style?: CSSProperties }) => {
  return (
    <SliderContainer draggable={false} style={props.style}>
      <Triangle style={{ transform: 'rotate(180deg)' }} />
      <SliderLine></SliderLine>
      <Triangle />
    </SliderContainer>
  )
}

const QualityContainer = styled.div`
  position: absolute;
  width: 480px;
  height: 96px;
  left: 60px;
  top: 320px;

  filter: drop-shadow(0px 80px 64px rgba(193, 198, 215, 0.17));
  border-radius: 8px;
  z-index: 99;
  background: rgba(252, 250, 252, 0.9);
  backdrop-filter: blur(6px);
`

const QualityText = styled.div`
  position: absolute;
  width: 72px;
  height: 18px;
  left: 24px;
  top: 20px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
`

const QualityBoldText = styled(QualityText)`
  left: unset;
  right: 24px;
  top: 20px;
  font-weight: 600;
  text-align: right;
`

const QualitySlider = styled.div`
  position: absolute;
  top: 64px;
  right: 24px;
  width: 430px;
  height: 4px;
  background: #e6e8eb;
  border-radius: 3.2px;
`

const QualityLine = styled.div`
  height: 100%;
  background: #3370ff;
  border-radius: 3.2px 0 0 3.2px;
  position: relative;
`

const QualityCircle = styled.div`
  background: #ffffff;
  border: 5px solid #3370ff;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.14);
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  transform: translateY(-50%);
  top: 50%;
  transition: border-radius ease 0.2s;
`

const Feat1Mask = styled.div`
  transition: all ease 0.2s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  border-radius: 12px;
`

const Feat2ImageContainer = styled.div`
  position: absolute;
  top: 168px;
  left: 40px;
  height: 520px;
  width: 480px;
  border-radius: 12px;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

const Feat31ImageContaienr = styled.div`
  position: absolute;
  top: 187px;
  left: 599px;
  width: 368px;
  height: 389px;
  filter: drop-shadow(0px 80px 98px rgba(217, 225, 250, 0.17)),
    drop-shadow(0px 33px 12px rgba(180, 190, 221, 0.12));
  border-radius: 12px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`

const Feat32ImageContaienr = styled.div`
  position: absolute;
  top: 187px;
  right: 61px;
  background: url(${feat32});
  width: 164px;
  height: 150px;
  border-radius: 8px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Feat33ImageContaienr = styled.div`
  position: absolute;
  top: 345px;
  right: 42px;
  background: url(${feat33});
  width: 183px;
  height: 115px;
  border-radius: 8px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Feat34ImageContaienr = styled.div`
  position: absolute;
  top: 468px;
  right: 80px;
  background: url(${feat34});
  width: 145px;
  height: 113px;
  border-radius: 8px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Feat2ActionContainer = styled.div`
  height: 86px;
  width: 88px;
  border-radius: 8px;
  background: rgba(252, 250, 252, 0.9);
  backdrop-filter: blur(6px);
  box-sizing: border-box;
  padding: 16px 24px;
  position: absolute;
  left: 501px;
`

const Feat2ActionText = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 22px;
`

const MaskContainer = styled.div`
  position: relative;
  pointer-events: none;
  transition-timing-function: ease, cubic-bezier(0.68, -0.6, 0.32, 1.6);
  transition-property: opacity, all;
  transition-duration: 0.2s, 0.8s;
  border-color: rgba(21, 22, 25, 0.3);
  border-style: solid;
`

const SwitchContainer = styled.div`
  height: 68px;
  width: 460px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  position: absolute;
  top: 535px;
  right: 40px;
  filter: drop-shadow(0px 80px 64px rgba(193, 198, 215, 0.17));
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  :before {
    border: 1px solid transparent;
  }
`

const SwitchText = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #282f38;
`

interface ActionProps {
  active: boolean
  style: CSSProperties
  icon: typeof About2
  text: string
}

const Feat2Action = (props: ActionProps) => {
  return (
    <Feat2ActionContainer
      style={{
        ...{
          backgroundColor: props.active ? '#3370FF' : 'rgba(252, 250, 252, 0.9)',
          transition: 'transform ease 0.2s',
        },
        ...props.style,
      }}
    >
      <props.icon
        fill={props.active ? 'white' : '#606A78'}
        width="24px"
        height="24px"
        style={{ transform: 'translateX(8px)' }}
      ></props.icon>
      <Feat2ActionText style={{ color: props.active ? 'white' : '#606A78' }}>
        {props.text}
      </Feat2ActionText>
    </Feat2ActionContainer>
  )
}

const MaskGroup = (props: { width: number; height: number; style: CSSProperties }) => {
  return (
    <MaskContainer
      style={{ width: `${props.width}px`, height: `${props.height}px`, ...props.style }}
    >
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '0',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '33.3%',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '66.6%',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '1px',
          top: '100%',
          backgroundImage: `linear-gradient(to bottom, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '0px',
          top: '0px',
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '33.3%',
          top: 0,
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '66.6%',
          top: 0,
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '1px',
          left: '100%',
          top: 0,
          backgroundImage: `linear-gradient(to right, transparent 0%, white 25%, transparent 50%)`,
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderLeft: '4px solid #FFFFFF',
          borderTop: '4px solid #FFFFFF',
          position: 'absolute',
          top: '-2px',
          left: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRight: '4px solid #FFFFFF',
          borderTop: '4px solid #FFFFFF',
          position: 'absolute',
          top: '-2px',
          right: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRight: '4px solid #FFFFFF',
          borderBottom: '4px solid #FFFFFF',
          position: 'absolute',
          right: '-2px',
          bottom: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderLeft: '4px solid #FFFFFF',
          borderBottom: '4px solid #FFFFFF',
          position: 'absolute',
          left: '-2px',
          bottom: '-2px',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderLeft: '4px solid #FFFFFF',
          position: 'absolute',
          left: '-2px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      ></div>
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRight: '4px solid #FFFFFF',
          position: 'absolute',
          right: '-2px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      ></div>
    </MaskContainer>
  )
}

const FeatContainer1 = () => {
  const [size, setSize] = useState(120)
  const [left, setLeft] = useState(50)
  const [quality, setQuality] = useState(0.4)
  const [radius, setRadius] = useState(12)
  const [color, setColor] = useState('unset')

  const init = () => {
    setSize(122)
    setLeft(50)
    setQuality(0.4)
  }

  const start = () => {
    setRadius(14)
  }
  useEffect(() => {
    if (radius === 14) {
      window.requestAnimationFrame(() => {
        if (quality < 0.6) {
          setQuality((quality) => quality + 0.01)
        } else {
          setQuality(0.6)
        }
      })
    }
  }, [quality, radius])

  useEffect(() => {
    if (quality === 0.6) {
      setRadius(12)
      window.requestAnimationFrame(() => {
        if (left < 300) {
          setLeft((left) => left + 6)
        } else {
          setLeft(300)
        }
      })
    }
  }, [quality, left])

  useEffect(() => {
    if (quality === 0.6) {
      setColor('black')
      window.requestAnimationFrame(() => {
        if (size > 40) {
          setSize((size) => size - 2)
        } else {
          setColor('unset')
          setSize(40)
        }
      })
    }
  }, [quality, size])

  useEffect(() => {
    if (left === 300) {
      setTimeout(() => {
        init()
        start()
      }, 2000)
    }
  }, [left])

  useEffect(() => {
    start()
  }, [])

  return (
    <Container
      style={{
        height: '780px',
        marginTop: '230px',
        position: 'relative',
      }}
    >
      <IconFeat1></IconFeat1>
      <div style={{ top: '323px', position: 'absolute' }}>
        <FeatTitle>支持</FeatTitle>
        <FeatActiveTitle>高压缩</FeatActiveTitle>
        <FeatTitle>图片格式转化</FeatTitle>
      </div>
      <FeatContent style={{ width: '397px', top: '403px' }}>
        保证图片视觉效果无损的基础上，支持转化为 HEIF 等高压缩图片格式，相比 WebP 体积小
        30%，在保持画质不变的前提下，节省更多成本。
      </FeatContent>
      <Feat1Cube></Feat1Cube>
      <Feat1ImgContainer>
        <img src={feat1Img} style={{ borderRadius: '12px' }}></img>
        <Feat1Mask style={{ backgroundColor: color }}></Feat1Mask>
        <Feat1Tag style={{ width: '113px', left: '15px', top: '15px' }}>
          原图 5MB
        </Feat1Tag>
        <Feat1Tag
          style={{ width: '154px', right: '15px', top: '15px' }}
        >{`ImageX ${size}KB`}</Feat1Tag>
        <Slider
          style={{
            height: '338px',
            left: `${left - 13.5}px`,
            opacity: quality === 0.6 ? '1' : '0',
          }}
        ></Slider>
        <QualityContainer>
          <QualityText>压缩质量</QualityText>
          <QualityBoldText>{`${Math.round(quality * 100)}%`}</QualityBoldText>
          <QualitySlider>
            <QualityLine style={{ width: `${430 * quality}px` }}>
              <QualityCircle
                style={{
                  left: `${430 * quality}px`,
                  width: `${radius * 2}px`,
                  height: `${radius * 2}px`,
                  borderRadius: `${radius}px`,
                }}
              ></QualityCircle>
            </QualityLine>
          </QualitySlider>
        </QualityContainer>
      </Feat1ImgContainer>
    </Container>
  )
}
const FeatContainer2 = () => {
  const [cutActive, setCutActive] = useState(false)
  const [cutScale, setCutScale] = useState(1)
  const [zoomScale, setZoomScale] = useState(1)
  const [showMask, setShowMask] = useState(false)
  const [zoomActive, setZoomActive] = useState(false)
  const [scale, setScale] = useState(0.5)
  const [imgScale, setImgScale] = useState(1)

  const start = () => {
    setTimeout(() => {
      setCutActive(true)
    }, 200)
    setTimeout(() => {
      setCutScale(0.9)
    }, 400)
    setTimeout(() => {
      setCutScale(1)
    }, 600)
    setTimeout(() => {
      setShowMask(true)
      setScale(0.8)
    }, 1000)
    setTimeout(() => {
      setCutActive(false)
    }, 2000)
    setTimeout(() => {
      setZoomActive(true)
    }, 2200)
    setTimeout(() => {
      setZoomScale(0.9)
    }, 2400)
    setTimeout(() => {
      setZoomScale(1)
    }, 2600)
    setTimeout(() => {
      setImgScale(1.2)
    }, 3000)
    setTimeout(() => {
      setImgScale(1)
    }, 4200)
    setTimeout(() => {
      setZoomActive(false)
    }, 4400)
    setTimeout(() => {
      setShowMask(false)
      setScale(0.5)
    }, 4600)
    setTimeout(() => {
      start()
    }, 4800)
  }

  useEffect(() => {
    start()
  }, [])
  const actions: ActionProps[] = [
    {
      icon: Zoom,
      text: '缩放',
      style: { top: '215px', transform: `scale(${zoomScale})` },
      active: zoomActive,
    },
    {
      icon: Cut,
      text: '裁剪',
      style: { top: '317px', transform: `scale(${cutScale})` },
      active: cutActive,
    },
    { icon: HorizontalFlip, text: '翻转', style: { top: '419px' }, active: false },
    { icon: Watermask, text: '水印', style: { top: '521px' }, active: false },
  ]
  return (
    <div style={{ background: '#F5F8FF', width: '100%', height: '780px' }}>
      <Container style={{ position: 'relative', height: '780px', margin: '0 auto' }}>
        <IconFeat2></IconFeat2>
        <div style={{ top: '352px', right: '31px', position: 'absolute' }}>
          <FeatTitle>支持丰富的</FeatTitle>
          <FeatActiveTitle>智能处理</FeatActiveTitle>
          <FeatTitle>操作</FeatTitle>
        </div>
        <FeatContent style={{ width: '427px', top: '432px', right: '0' }}>
          支持包括支持个性化裁剪、缩放、图文水印、格式压缩等多种智能处理编辑操作，丰富的
          AI 能力持续更新。
        </FeatContent>
        <Feat2Cube></Feat2Cube>
        <Feat2ImageContainer>
          <img
            src={feat2Img}
            style={{
              transform: `scale(${imgScale})`,
              transition: 'all ease 0.4s',
              objectFit: 'cover',
              height: '520px',
              width: '480px',
              position: 'absolute',
            }}
          ></img>
          <MaskGroup
            width={480 * scale}
            height={520 * scale}
            style={{
              borderLeftWidth: `${(480 - 480 * scale) / 2}px`,
              borderRightWidth: `${(480 - 480 * scale) / 2}px`,
              borderTopWidth: `${(520 - 520 * scale) / 2}px`,
              borderBottomWidth: `${(520 - 520 * scale) / 2}px`,
              opacity: showMask ? '1' : '0',
            }}
          ></MaskGroup>
        </Feat2ImageContainer>
        {actions.map((action) => {
          return <Feat2Action {...action} key={action.text}></Feat2Action>
        })}
      </Container>
    </div>
  )
}
const FeatContainer3 = () => {
  const [scale, setScale] = useState(1)
  const [opcity, setOpcity] = useState(0)
  const [check, setCheck] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const [smallScale, setSmallScale] = useState(0.8)

  const init = () => {
    setScale(1)
    setOpcity(0)
    setShowAll(false)
    setCheck(false)
    setSmallScale(0.8)
  }

  const start = () => {
    setOpcity(1)
  }
  useEffect(() => {
    if (opcity === 1) {
      setScale(1.3)
    }
  }, [opcity])

  useEffect(() => {
    if (scale === 1.3) {
      setTimeout(() => {
        setCheck(true)
      }, 800)
    }
  }, [scale])

  useEffect(() => {
    if (check) {
      setTimeout(() => {
        setShowAll(true)
        setSmallScale(1)
      }, 800)
      setTimeout(() => {
        init()
      }, 1800)
      setTimeout(() => {
        start()
      }, 2800)
    }
  }, [check])

  useEffect(() => {
    start()
  }, [])

  return (
    <Container
      style={{
        height: '780px',
        background: 'white',
        position: 'relative',
      }}
    >
      <IconFeat3></IconFeat3>
      <div style={{ top: '323px', position: 'absolute' }}>
        <FeatTitle>使用</FeatTitle>
        <FeatActiveTitle>便捷</FeatActiveTitle>
      </div>
      <FeatContent style={{ width: '408px', top: '403px' }}>
        产品界面设计简洁，操作便捷，上传您需优化的图片后，仅需通过简单点击和配置操作，即可获得优化后的图片效果，同时支持多张图片批量操作。
      </FeatContent>
      <Feat3Cube></Feat3Cube>
      <Feat31ImageContaienr>
        <img
          src={feat31}
          style={{
            borderRadius: '8px',
            width: '100%',
            height: '100%',
            position: 'absolute',
          }}
        ></img>
        <div style={{ opacity: opcity }}>
          <IconMask
            style={{
              width: '222px',
              height: '56px',
              transform: `scale(${scale})`,
              transition: 'transform 0.6s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
            }}
          ></IconMask>
        </div>
      </Feat31ImageContaienr>
      <Feat32ImageContaienr>
        <IconMask
          style={{
            width: '112px',
            height: '28px',
            opacity: showAll ? '1' : 0,
            transform: `scale(${smallScale})`,
            transition: 'transform 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
          }}
        ></IconMask>
      </Feat32ImageContaienr>
      <Feat33ImageContaienr>
        <IconMask
          style={{
            width: '112px',
            height: '28px',
            opacity: showAll ? '1' : 0,
            transform: `scale(${smallScale})`,
            transition: 'transform 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
          }}
        ></IconMask>
      </Feat33ImageContaienr>
      <Feat34ImageContaienr>
        <IconMask
          style={{
            width: '112px',
            height: '28px',
            opacity: showAll ? '1' : 0,
            transform: `scale(${smallScale})`,
            transition: 'transform 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
          }}
        ></IconMask>
      </Feat34ImageContaienr>
      <SwitchContainer>
        <Switch checked={check} style={{ marginRight: '20px' }}></Switch>
        <SwitchText>将当前模版应用到所有图片</SwitchText>
      </SwitchContainer>
    </Container>
  )
}

const About = function About() {
  const [active, setActive] = useState(false)
  return (
    <PageContainer>
      <NavGroupContainer>
        <Affix onChange={setActive}>
          <Header active={active}>
            <Container>
              <Icon onClick={() => window.open('/')}>
                <IconAbout style={{ transform: 'translateY(-2px)' }}></IconAbout>
              </Icon>
              <ActionContainer>
                <Diamond src={diamond}></Diamond>
                <Text
                  onClick={() => {
                    reportTea('click_advance', {
                      url_path: '/about',
                      type: 'nav',
                    })
                    window.open(
                      'https://www.volcengine.cn/products/imagex?utm_content=ImageX&utm_source=10zb5a&utm_term=ImageX-breif',
                    )
                  }}
                  style={{ marginRight: '24px' }}
                >
                  企业版
                </Text>
                <ActiveText
                  onClick={() => {
                    reportTea('click_experience')
                    window.open('/')
                  }}
                  active={active}
                >
                  立即体验
                </ActiveText>
              </ActionContainer>
            </Container>
          </Header>
        </Affix>
        <Container
          style={{ justifyContent: 'center', marginTop: '120px', position: 'relative' }}
        >
          <Title>一站式图像智能处理平台</Title>
          <IconAbout2></IconAbout2>
        </Container>
        <Container style={{ justifyContent: 'center', marginTop: '24px' }}>
          <Content>
            veImageX 体验版可实现针对 PNG、JPEG、GIF、WebP、HEIF、AVIF
            等多种格式图片的压缩处理，以及图片旋转、缩放、裁剪、图文水印等多种智能处理。
          </Content>
        </Container>
        <Container
          style={{ justifyContent: 'center', marginTop: '32px', position: 'relative' }}
        >
          <ActiveButton
            onClick={() => {
              reportTea('click_experience')
              window.open('/')
            }}
          >
            立即体验
            <ArrowContaienr>
              <IconArrowRight className="arrow-right" />
            </ArrowContaienr>
          </ActiveButton>
          <IconAbout1 src={About1} draggable="false"></IconAbout1>
        </Container>
        <Container style={{ justifyContent: 'center', marginTop: '40px' }}>
          <ProductImg src={productImg} width="1080px" height="654px"></ProductImg>
        </Container>
      </NavGroupContainer>
      <FeatContainer1></FeatContainer1>
      <FeatContainer2></FeatContainer2>
      <FeatContainer3></FeatContainer3>

      <div
        style={{
          width: '100%',
          background: '#F2F7FF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '652px',
        }}
      >
        <Container
          style={{
            justifyContent: 'center',
            paddingTop: '80px',
          }}
        >
          <div>
            <H2>更多</H2>
            <ActiveH2>核心优势</ActiveH2>
          </div>
        </Container>
        <Container
          style={{
            justifyContent: 'center',
            paddingTop: '12px',
          }}
        >
          <Content style={{ justifyContent: 'center' }}>
            veImageX 提供实时快速转化能力，可在线使用，并提供安全可靠的服务
          </Content>
        </Container>
        <Container
          style={{
            justifyContent: 'space-between',
            paddingTop: '60px',
          }}
        >
          <CardContainer>
            <More1></More1>
            <MoreTitle>实时快速转化</MoreTitle>
            <MoreContent>云端实时高效处理，不受限于本地设备和操作系统性能</MoreContent>
          </CardContainer>
          <CardContainer>
            <More2></More2>
            <MoreTitle>在线使用</MoreTitle>
            <MoreContent>无需下载或安装任何程序，即可完成图像处理</MoreContent>
          </CardContainer>
          <CardContainer>
            <More3></More3>
            <MoreTitle>服务安全可靠</MoreTitle>
            <MoreContent>图片素材临时存储，1 小时后永久删除，保障图片安全</MoreContent>
          </CardContainer>
        </Container>
      </div>
      <div
        style={{
          width: '100%',
          background: `linear-gradient(rgba(248, 251, 255, 0.2) 0%, rgba(245, 248, 255, 0.7) 100%)`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '2195px',
        }}
      >
        <Container
          style={{
            justifyContent: 'center',
            paddingTop: '80px',
          }}
        >
          <div>
            <H2>服务介绍</H2>
          </div>
        </Container>
        <Container
          style={{
            justifyContent: 'center',
            paddingTop: '12px',
          }}
        >
          <Content style={{ justifyContent: 'center' }}>
            您可以根据需要，选择更适合您的产品方案
          </Content>
        </Container>
        <Container
          style={{
            justifyContent: 'space-between',
            paddingTop: '60px',
          }}
        >
          <IntroContaienr>
            <IntroTitle>veImageX（体验版）</IntroTitle>
            <IntroContent style={{ width: '420px' }}>
              满足小批量图片的基础处理和格式转化需求，轻量快捷的编辑图片内容
            </IntroContent>
            <IntroItem text="常规图像文件格式"></IntroItem>
            <IntroItem text="高压缩 HEIF 与 AVIF 文件格式"></IntroItem>
            <IntroItem text="11 类基础图片处理能力"></IntroItem>
            <IntroItem text="6 类高阶图片处理能力"></IntroItem>
            <IntroItem text="有限的使用权限"></IntroItem>
            <ActiveButton
              style={{
                width: '130px',
                height: '48px',
                fontSize: '16px',
                lineHeight: '28px',
                padding: '10px 20px',
                position: 'absolute',
                left: '60px',
                bottom: '40px',
              }}
              onClick={() => {
                reportTea('click_experience')
                window.open('/')
              }}
            >
              立即体验
              <ArrowContaienr>
                <IconArrowRight className="arrow-right" />
              </ArrowContaienr>
            </ActiveButton>
            <IconIntro1></IconIntro1>
          </IntroContaienr>
          <IntroContaienr>
            <IntroTitle>veImageX（企业版）</IntroTitle>
            <IntroContent style={{ width: '420px' }}>
              提供便捷的一站式图片上传、存储、处理、分发服务，覆盖大批量图片全链路处理需求
            </IntroContent>
            <IntroItem text="veImageX 体验版的所有功能"></IntroItem>
            <IntroItem text="高压缩 HEIF 与 AVIF 文件格式"></IntroItem>
            <IntroItem text="11 类基础图片处理能力"></IntroItem>
            <IntroItem text="9 类高阶图片处理能力"></IntroItem>
            <IntroItem text="无限的使用权限"></IntroItem>
            <ActiveButton
              style={{
                width: '130px',
                height: '48px',
                fontSize: '16px',
                lineHeight: '28px',
                padding: '10px 20px',
                position: 'absolute',
                left: '60px',
                bottom: '40px',
              }}
              onClick={() => {
                reportTea('click_advance', {
                  url_path: '/about',
                  type: 'try',
                })
                window.open(
                  'https://www.volcengine.cn/products/imagex?utm_content=ImageX&utm_source=10zb5a&utm_term=ImageX-tryout',
                )
              }}
            >
              立即试用
              <ArrowContaienr>
                <IconArrowRight className="arrow-right" />
              </ArrowContaienr>
            </ActiveButton>
            <IconIntro2></IconIntro2>
          </IntroContaienr>
        </Container>
        <Container style={{ justifyContent: 'center', marginTop: '60px' }}></Container>
        <TabContainer style={{ marginBottom: '16px' }}>
          <TabCell1>
            <TabTitle>服务说明</TabTitle>
          </TabCell1>
          <TabCell2>
            <TabTitle>体验版</TabTitle>
          </TabCell2>
          <TabCell3>
            <TabTitle>企业版</TabTitle>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '60px', background: ' #F5F8FF' }}>
          <TabCell1>
            <TableHeader>支持的图片格式</TableHeader>
          </TabCell1>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>常规图像文件格式（包括 PNG、JPEG、WebP、GIF）</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px' }}>
          <TabCell1>
            <TabContent>高压缩图像文件格式（包括 HEIF、AVIF）</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '60px', background: ' #F5F8FF' }}>
          <TabCell1>
            <TableHeader>支持的基础处理能力</TableHeader>
          </TabCell1>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>图片压缩/格式转化</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>图片旋转/翻转</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>图片缩放</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>图片裁剪</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>添加图文水印</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>锐化</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              负片
              <Popover
                content={
                  '经曝光和显影加工后得到的影像，其明暗与被摄体相反，其色彩为被摄体的补色'
                }
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>亮度调节</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              高斯模糊
              <Popover
                content={
                  '主要用于降低图像噪声和减少图像细节，其视觉效果类似通过一个半透明屏幕观察图像'
                }
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>对比度调节</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px' }}>
          <TabCell1>
            <TabContent>饱和度调节</TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '60px', background: ' #F5F8FF' }}>
          <TabCell1>
            <TableHeader>支持的高阶处理能力</TableHeader>
          </TabCell1>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              漫画风格迁移
              <Popover content={'将输入图像按照漫画风格输出，使得图像色彩、笔触等漫画化'}>
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Line></Line>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              智能识别裁剪
              <Popover
                content={
                  '对输入图片进行指定尺寸变换时，可自动识别人像主体区域位置，采用最佳裁剪方式'
                }
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              智能抠图（支持人像/商品抠图）
              <Popover content={'将图片主体和背景分割，抠除背景并生成透明底图片'}>
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              智能识别填充
              <Popover
                content={
                  '将图片背景通过算法进行填充达到特定大小的效果，填充内容和原图背景自然融合'
                }
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Line></Line>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              图像内容擦除
              <Popover
                content={'擦除图片指定区域内全部内容或指定贴片内容，并智能补全擦除部位'}
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Line></Line>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              画质增强
              <Popover content={'支持将低质模糊的图片进行AI处理，提升图片整体清晰度'}>
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              图像超分辨率
              <Popover
                content={
                  '对图片做2-4倍超分智能放大，同时基于推断出的细节保持结果图像的清晰度'
                }
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>
              盲水印
              <Popover
                content={
                  '可将水印以用户不可见的形式添加到原图信息中，并不会对原图质量产生影响'
                }
              >
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px' }}>
          <TabCell1>
            <TabContent>
              画质评分
              <Popover content={'基于用户主观感知的图像清晰度和美学评分'}>
                <Question style={{ marginLeft: '6px', cursor: 'pointer' }}></Question>
              </Popover>
            </TabContent>
          </TabCell1>
          <TabCell2>
            <Yes></Yes>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '60px', background: ' #F5F8FF' }}>
          <TabCell1>
            <TableHeader>使用限制</TableHeader>
          </TabCell1>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>上传图片总数</TabContent>
          </TabCell1>
          <TabCell2>
            <TabContent>每日最多 100 张</TabContent>
          </TabCell2>
          <TabCell3>
            <TabContent>无限制</TabContent>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>并发处理图片数量</TabContent>
          </TabCell1>
          <TabCell2>
            <TabContent>最多 10 张</TabContent>
          </TabCell2>
          <TabCell3>
            <TabContent>无限制</TabContent>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>图片操作有效期</TabContent>
          </TabCell1>
          <TabCell2>
            <TabContent>上传后 1 小时内</TabContent>
          </TabCell2>
          <TabCell3>
            <TabContent>永久</TabContent>
          </TabCell3>
        </TabContainer>
        <TabContainer style={{ height: '52px', borderBottom: '1px solid #F4F4F4' }}>
          <TabCell1>
            <TabContent>图片处理模版导出/保存</TabContent>
          </TabCell1>
          <TabCell2>
            <Line></Line>
          </TabCell2>
          <TabCell3>
            <Yes></Yes>
          </TabCell3>
        </TabContainer>
      </div>
      <BannerContainer>
        <BannerTitle>联系我们</BannerTitle>
        <BannerContent>
          想了解 veImageX
          为您带来的更多价值，请留下您的联系方式，我们的咨询顾问将结合您的业务为您做详细介绍
        </BannerContent>
        <BannerBtn
          onClick={() => {
            reportTea('click_contact')
            window.open('https://www.volcengine.cn/contact/product?t=veImageXlite')
          }}
        >
          立即咨询
        </BannerBtn>
      </BannerContainer>
      <Footer>
        版权所有©北京火山引擎科技有限公司2020-2021 京公网安备11010802032137号 |
        京ICP备20018813号-2
      </Footer>
    </PageContainer>
  )
}

export default About
